const actions = {
  TOGGLE: "TOGGLE",
  GET_ORGANIZATION: "GET_ORGANIZATION",
  GET_MEMBERS: "GET_MEMBERS",
  GET_DATA_CHART: "GET_DATA_CHART",
  GET_DATA_PIE: "GET_DATA_PIE",
  CHART_FILTERS: "CHART_FILTERS",
  GET_USAGE_BY_MEMBER: "GET_USAGE_BY_MEMBER",
  GET_ACTIVITY: "GET_ACTIVITY",
  GET_REMAINING: "GET_REMAINING",
};

export default actions;
